import { Fragment } from 'react';
import type { NotificationBar as NotificationBarSchema } from '@amplience/content-types/typings/c-notification-bar';
import { FlexibleTextPartial } from '../../../partials/flexibleText';
import { hasHref } from '../../../partials/link';
import { TypographyStylesType, colours } from '../../../stylings';
import { NotificationBarContainer, NotificationBarItem, NotificationBarLink } from './NotificationBar.styles';

export type NotificationBarProps = NotificationBarSchema;

export function NotificationBar({ notificationBarComponents, backgroundColor, _meta }: NotificationBarProps) {
  const isDisplayed = notificationBarComponents?.find(({ notificationLink }) =>
    notificationLink?.find(({ text }) => text.text),
  );

  if (!isDisplayed) return null;

  return (
    <NotificationBarContainer id="clarks-notification-bar">
      {notificationBarComponents?.map(({ notificationLink }, idx) => (
        <NotificationBarItem
          backgroundColor={backgroundColor}
          key={`${_meta?.deliveryId}-${notificationLink[0]?.link.internalLink || idx}`}
        >
          {notificationLink.map(
            ({ text, link }, i) =>
              text && (
                <Fragment key={`${_meta?.deliveryId}-${text.text || i}`}>
                  {hasHref(link) ? (
                    <NotificationBarLink {...link} $textColor={text.textColor} $defaultTextColor={colours.WHITE}>
                      <FlexibleTextPartial
                        {...text}
                        defaultTextSize={TypographyStylesType.CTA_TINY_SEMIBOLD}
                        defaultTextColor={colours.WHITE}
                      />
                    </NotificationBarLink>
                  ) : (
                    <FlexibleTextPartial
                      {...text}
                      defaultTextSize={TypographyStylesType.CTA_TINY_SEMIBOLD}
                      defaultTextColor={colours.WHITE}
                    />
                  )}
                </Fragment>
              ),
          )}
        </NotificationBarItem>
      ))}
    </NotificationBarContainer>
  );
}
